var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCsa12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_5",
    "data-name": "Calque 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.5,0H62.5A62.65,62.65,0,0,0,0,62.5v250A62.65,62.65,0,0,0,62.5,375h375A62.65,62.65,0,0,0,500,312.5V62.5A62.65,62.65,0,0,0,437.5,0ZM156.3,225H68.8V193.8h87.5Zm106.2,59.3H228.1V128.1H225l-46.9,34.4V131.3l50-34.4h34.4Zm168.8,0H300v-25l65.6-65.6c25-25,31.2-31.2,31.2-46.9s-12.4-31.2-31.1-31.2c-21.9,0-34.4,12.5-34.4,34.4H300.1c0-34.4,28.1-59.4,65.6-59.4s62.5,21.9,62.5,53.1c0,21.9-9.4,37.5-40.6,68.8l-43.8,40.6v3.1h84.4l3.1,28.1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCsa12);
export default __webpack_public_path__ + "static/media/icon-csa-12.01afc1e4bccd5c4afa278fa8a866c2ef.svg";
export { ForwardRef as ReactComponent };